import { SET_ACCOUNT_ID, SET_OTPMETHOD, SET_PASSWORD, SET_PRACTICE_ID, SET_USERNAME, SET_USER_PROFILE } from "./types";

export const setPracticeId = (id) => ({
  type: SET_PRACTICE_ID,
  payload: id,
});

export const setAccountId = (id) => ({
  type: SET_ACCOUNT_ID,
  payload: id,
});

export const setUserProfile = (profile) => ({
  type: SET_USER_PROFILE,
  payload: profile,
});

export const setUsername = (username) => ({
  type: SET_USERNAME,
  payload: username,
})

export const setPassword = (password) => ({
  type: SET_PASSWORD,
  payload: password,
})

export const setOtpType = (method) => ({
  type: SET_OTPMETHOD,
  payload: method,
})